import { useContext } from 'react'
import PropTypes from 'prop-types'

import { digObject } from '@domain-group/javascript-utils'

import {
  Button, FileInput, Form, ModalContext, SectionDivider, SidebarModal,
} from '@domain-group/suit-theme'

import useProvider, { useProviderForm } from '@hooks/useProvider'

import UploadedPDF from './UploadedPDF'

const EditProviderCustomInvoiceModal = (props) => {
  const { callbacks, modalKey, showModal } = props
  const { closeModal, updateProvider } = callbacks

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, modalKey, {})
  const { provider } = modalPayload

  const {
    callbacks: {
      updateProvider: updateFn,
    },
    updating,
  } = useProvider(provider)

  const { invoice_pdf } = provider

  const useProviderFormPayload = useProviderForm(provider)
  const {
    entityState,
    entityState: {
      details_colour,
      font_colour,
      font_light_colour,
      highlight_colour,
    },
    handlers,
    setEntityState,
    saveEnabled,
  } = useProviderFormPayload

  const hasInvoicePDF = !!invoice_pdf

  const customInvoicePayload = {
    callbacks: {
      action: updateFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    requestOptions: {
      include_provider_invoice_pdf: true,
    },
    toastText: 'Custom Invoice Updated',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="Add" titleSecondLine="Invoice Details" />

      <SidebarModal.Content>
        <Form>
          <Form.Field label="Font Colour">
            <input
              name="font_colour"
              type="text"
              value={font_colour}
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Details Colour" marginTop="large">
            <input
              name="details_colour"
              type="text"
              value={details_colour}
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Light Font Colour" marginTop="large">
            <input
              name="font_light_colour"
              type="text"
              value={font_light_colour}
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Highlight Colour" marginTop="large">
            <input
              name="highlight_colour"
              type="text"
              value={highlight_colour}
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Invoice PDF" marginTop="large">
            <FileInput
              input={{
                onChange: (fileData, fileObject) => {
                  setEntityState({
                    invoice_pdf_file: fileData,
                    invoice_pdf_file_name: fileObject.name,
                  })
                },
              }}
            />
          </Form.Field>
        </Form>

        {hasInvoicePDF && (
          <>
            <SectionDivider boxProps={{ paddingY: 'large' }}>Uploaded Invoice PDF</SectionDivider>

            <UploadedPDF provider={provider} />
          </>
        )}
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={updating}
          onClick={() => updateProvider(customInvoicePayload)}
          size="large"
        >
          Save Invoice Details
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

EditProviderCustomInvoiceModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

EditProviderCustomInvoiceModal.defaultProps = {
  modalKey: 'EditProviderCustomInvoiceModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <EditProviderCustomInvoiceModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
